import Vue from 'vue';
import VueI18n from 'vue-i18n';
import _ from 'lodash';
import zh from './lang/zh';
import zhTW from './lang/zh-tw';
import en from './lang/en';
import ko from './lang/ko';
import ja from './lang/ja';
import es from './lang/es';  // 西班牙语
import fil from './lang/fil';  // 菲律宾语
import hi from './lang/hi'; // 印地语
import pt from './lang/pt'; // 葡萄牙语
import ru from './lang/ru'; // 俄语
import th from './lang/th'; // 泰语
import vi from './lang/vi'; // 越南语

Vue.use(VueI18n);

const availableLocale = ['zh', 'en', 'ko', 'ja', 'zh-tw', 'es', 'fil', 'hi', 'pt', 'ru', 'th', 'vi'];

let defaultLangStr = navigator.language;
let defaultLang = 'zh';

if (defaultLangStr.indexOf('en') >= 0) {
    defaultLang = 'en';
}

const query = location.search.substr(1);
let queryObj = {};

if (query) {
    _.forEach(query.split('&'), item => {
        const tempArr = item.split('=');
        queryObj[tempArr[0]] = tempArr[1];
    });
}

let locale = _.includes(availableLocale, queryObj['locale']) ? queryObj['locale'] : defaultLang;

locale = localStorage.getItem('locale') || locale;

// document.title = locale === 'en' ? 'Key Generator | TokenPocket' : '公私钥生成器 | TokenPocket';

switch (locale) {
  case 'en':
    document.title = 'Version Check'
    break;
  case 'zh':
    document.title = '版本检测'
    break;
  case 'ko':
    document.title = '버전 확인'
    break;
  case 'ja':
    document.title = 'バージョンチェック'
    break;
  case 'es':
    document.title = 'Comprobación de versión'
    break;
  case 'fil':
    document.title = 'Pag-check ng Bersyon'
    break;
  case 'hi':
    document.title = 'संस्करण जांच'
    break;
  case 'pt':
    document.title = 'Verificação de Versão'
    break;
  case 'ru':
    document.title = 'Проверка версии'
    break;
  case 'th':
    document.title = 'การตรวจสอบเวอร์ชัน'
    break;
  case 'vi':
    document.title = 'Kiểm tra phiên bản'
    break;
  case 'zh-tw':
    document.title = '版本檢測'
    break;
  default:
    break;
}

const i18n = new VueI18n({
    locale,
    messages: {
        'en': en,
        'zh': zh,
        'zh-tw': zhTW,
        'ko': ko,
        'ja': ja,
        'es': es,
        'fil': fil,
        'hi': hi,
        'pt': pt,
        'ru': ru,
        'th': th,
        'vi': vi,
    }
});

export default i18n;
